import React from "react";
import { Box } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PersonIcon from "@mui/icons-material/Person";
import AddIcon from "@mui/icons-material/Add";
import HeaderMenuItem from "./HeaderMenuItem";

/**
 * 未ログイン（ゲスト）時に表示するヘッダー右側コンテンツ
 *
 * - お役立ち情報（外部リンク）
 * - 新規登録
 * - ログイン
 *
 */
export default function GuestHeader({
  blogUrl = "https://skilllog.jp/blog/",
  signUpUrl = "/users/sign_up",
  loginUrl = "/users/sign_in",
}) {
  return (
    <Box
      component="ul"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        textAlign: "center",
        m: 0,
        p: 0,
        listStyle: "none",
        "& > li": {
          display: "flex",
          alignItems: "center",
        },
        "& > li + li": {
          borderLeft: "1px solid",
          borderColor: "grey.300",
        },
      }}
    >
      <Box component="li">
        <HeaderMenuItem
          label="お役立ち情報"
          icon={<InfoOutlinedIcon />}
          href={blogUrl}
          external
        />
      </Box>

      <Box component="li">
        <HeaderMenuItem
          label="新規登録"
          icon={<AddIcon />}
          href={signUpUrl}
        />
      </Box>

      <Box component="li">
        <HeaderMenuItem
          label="ログイン"
          icon={<PersonIcon />}
          href={loginUrl}
        />
      </Box>
    </Box>
  );
}
